import React from 'react';
import { Paper, withStyles } from '@material-ui/core';
import PermissionForm from './PermissionForm'
import * as Yup from "yup";
import * as actions from "./store/permissionActions";
import { connect } from "react-redux";
import { BackButton, hasPermission } from '../../sc-utilities';
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }

});
const PermissionCreate = props => {
    const { activeCustomer, translations, classes, loading, permissions } = props;
    const handleSubmit = data => {
        // Prepare the form data
        let result = props.createPermission({ ...data, ActiveCustomerID: activeCustomer });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = { Name: "", Key: "", Module: '' };
    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            Key: Yup.string().required("Required"),
        },
        FormTitle: translations['create_permission'] || "Create permission",
        ButtonSubmit: hasPermission(permissions, "permission_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    // Render form
    return (
        <Paper className={classes.root}   >
            {BackButton(translations)}
            <PermissionForm
                classes={classes}
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                loading={loading}
                translations={translations}
            ></PermissionForm>
        </Paper>
    );
};
const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},

    };
};

const mapDispatchToProps = dispatch => {
    return {
        createPermission: data => dispatch(actions.createPermissions(data)),
    };
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(PermissionCreate));
